module.exports = __webpack_public_path__ + "img/happytogether_main_03.4c679bd4.jpg";